import { useContext } from "react";
import { useSelector } from "react-redux";

import { BaseBenefitsList } from "../../../../components/BaseComponents/BaseBenefitsList";
import { BaseColumnInformation } from "../../../../components/BaseComponents/BaseColumnInformation";
import { BaseCompanyLogo } from "../../../../components/BaseComponents/BaseCompanyLogo";
import BaseCompanyName from "../../../../components/BaseComponents/BaseCompanyName";
import { BaseFeaturedCompanyHeader } from "../../../../components/BaseComponents/BaseFeaturedCompanyHeader";
import BaseGridRatingHorizontal from "../../../../components/BaseComponents/BaseGridRatingHorizontal";
import BaseLinkWrapper from "../../../../components/BaseComponents/BaseLinkWrapper";
import BaseProductDescription from "../../../../components/BaseComponents/BaseProductDescription";
import BaseReviewLink from "../../../../components/BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../../../components/BaseComponents/BaseServiceFlag";
import { BaseSocialProof } from "../../../../components/BaseComponents/BaseSocialProof";
import { BaseVisitLink } from "../../../../components/BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../../../components/CompanyList/CompanyContext";
import { getAwardText } from "../../../../selectors";
import { RightIcon } from "../../../assets/icons/RightIcon";
import { getStyles } from "./styles";

export const BusinessBankingCompany = () => {
	const { company, companyIndex, isFeaturedCompany } =
		useContext(CompanyContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));
	const styles = getStyles(companyIndex);

	return (
		<div
			className={`tw:relative tw:mt-[16px] tw:rounded-[3px] tw:bg-white tw:desktop:first:mt-[28px] ${isFeaturedCompany ? "tw:[border:1px_solid_#0D8AE3]" : ""}`}
		>
			<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />
			<div className="tw:relative tw:mx-auto tw:flex tw:max-w-[500px] tw:flex-col tw:px-[16px] tw:py-[20px] tw:desktop:max-w-none tw:desktop:flex-row tw:desktop:p-[24px]">
				<BaseServiceFlag classNames={styles.serviceFlag} />

				<div
					className={`tw:flex tw:pt-[28px] tw:desktop:w-[30%] ${awardText ? "tw:desktop:py-12" : "tw:desktop:py-0"}`}
				>
					<BaseLinkWrapper className="tw:flex tw:w-full tw:items-center tw:justify-between tw:gap-[16px] tw:desktop:flex-col tw:desktop:justify-center tw:desktop:gap-[20px] tw:[&:not(:has(>_div))]:justify-center">
						<BaseCompanyLogo classNames={styles.companyLogo} />

						<BaseGridRatingHorizontal classNames={styles.rating} />
					</BaseLinkWrapper>
				</div>

				<div className="tw:flex tw:flex-col tw:pt-[16px] tw:desktop:w-[70%] tw:desktop:flex-row tw:desktop:justify-between tw:desktop:gap-[20px] tw:desktop:p-0">
					<div className="tw:grow">
						<BaseCompanyName className="tw:hidden tw:font-montserrat tw:text-[24px] tw:leading-[32px] tw:font-bold tw:tracking-[-0.48px] tw:text-[#333641] tw:desktop:block tw:[&:not(:has(+_.peer-base-product-description))]:mb-[16px]" />

						<BaseProductDescription className="peer-base-product-description tw:mb-[16px] tw:font-montserrat tw:text-[20px] tw:leading-[32px] tw:font-semibold tw:tracking-[-0.4px] tw:text-[#333641]" />

						<BaseLinkWrapper className="tw:mb-[16px] tw:scrollbar-none tw:block tw:overflow-x-auto tw:desktop:mb-0">
							<BaseColumnInformation classNames={styles.columnInformation} />
						</BaseLinkWrapper>

						<BaseLinkWrapper className="tw:relative tw:inline-flex tw:min-h-[48px] tw:w-full tw:items-center tw:justify-center tw:gap-[12px] tw:rounded-[3px] tw:bg-[#00B679] tw:text-[18px] tw:leading-[24px] tw:font-semibold tw:tracking-[-0.18px] tw:text-white tw:transition-all tw:after:h-[16px] tw:after:w-[16px] tw:after:bg-[url(/public/react-images/common/newTab.svg)] tw:after:bg-cover tw:after:bg-no-repeat tw:hover:bg-[#008F66] tw:desktop:hidden">
							<BaseVisitLink contentWrapper="tw:block tw:pt-[3px]">
								View Rates
							</BaseVisitLink>
						</BaseLinkWrapper>

						{companyIndex === 0 && (
							<BaseSocialProof {...styles.mobileSocialProof} />
						)}

						<BaseLinkWrapper className="tw:mt-[24px] tw:block">
							<BaseBenefitsList
								{...styles.benefitsList}
								isExpandable={true}
								mobileItemsToShow={2}
							/>
						</BaseLinkWrapper>
					</div>

					<div className="tw:flex tw:flex-col tw:items-start tw:justify-center tw:desktop:items-center">
						{companyIndex === 0 && <BaseSocialProof {...styles.socialProof} />}

						<BaseLinkWrapper className="tw:relative tw:hidden tw:min-h-[56px] tw:w-full tw:items-center tw:justify-center tw:gap-[12px] tw:rounded-[3px] tw:bg-[#00B679] tw:text-[20px] tw:leading-[24px] tw:font-semibold tw:tracking-[-0.18px] tw:text-white tw:transition-all tw:after:h-[20px] tw:after:w-[20px] tw:after:bg-[url(/public/react-images/common/newTab.svg)] tw:after:bg-cover tw:after:bg-no-repeat tw:hover:bg-[#008F66] tw:desktop:inline-flex tw:desktop:w-[175px] tw:lg2:w-[200px]">
							<BaseVisitLink contentWrapper="tw:block tw:pt-[3px]">
								View Rates
							</BaseVisitLink>
						</BaseLinkWrapper>

						<BaseReviewLink
							classNames={styles.reviewLink}
							linkText="Read Full Review"
							prefixIcon={
								<RightIcon className="tw:text-[24px] tw:desktop:hidden" />
							}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
